import React from 'react';
import styled from 'styled-components';

const DesktopDropdownGroup = (props) => {
  const { children, label } = props;
  return (
    <Wrapper>
      {label && <Label>{label}</Label>}
      {children}
    </Wrapper>
  );
};

const Wrapper = styled.div``;

const Label = styled.span`
  font-size: var(--font-size-sm);
  display: block;
  color: var(--gray-dark);
  padding: 15px 15px 10px;
`;

export default DesktopDropdownGroup;
